module.exports = __webpack_public_path__ + "img/5.1a0e3d75.png";